import { useMemo } from 'react';
import { useProjectStore, type SelectionTarget } from '../../../state/projectStore';

/** The page or cover panel that new elements/templates should apply to. */
export function useCurrentTarget(): SelectionTarget | null {
  const project = useProjectStore((s) => s.project);
  const view = useProjectStore((s) => s.view);
  const selection = useProjectStore((s) => s.selection);

  return useMemo(() => {
    if (selection.target) return selection.target;
    if (!project) return null;
    if (view.mode === 'cover') return { scope: 'cover', panel: 'front' };
    const leftPage = project.pages.find((p) => p.order === view.spreadIndex * 2);
    return leftPage ? { scope: 'page', pageId: leftPage.id } : null;
  }, [selection.target, project, view]);
}
